import {
  DetailHeader,
  DetailHeaderRow,
  DetailHeaderSection,
} from 'components/DetailHeader/DetailHeader';
import React, { type FC } from 'react';

import { LinkIcon } from '@fragment/ui/src/components/Icon/LinkIcon/LinkIcon';
import type { CurrencyMode } from '@fragment/ui/src/types/customerApi';
import type { FormatCurrency } from '@fragment/ui/src/utils/currency';
import { formatAccountCurrency } from '@fragment/ui/src/utils/currency';

import type { LinkNode } from './types';

type ExternalAccountSummaryProps = {
  externalAccountId: string;
  externalAccountName: string;
  linkType: LinkNode['__typename'];
  accountSelector: React.ReactNode;
  currencyMode: CurrencyMode;
  currency?: FormatCurrency | null | undefined;
};

export const ExternalAccountSummary: FC<ExternalAccountSummaryProps> = ({
  externalAccountId,
  externalAccountName,
  linkType,
  accountSelector,
  currencyMode,
  currency,
}) => (
  <DetailHeader>
    <DetailHeaderSection>
      <DetailHeaderRow
        label="External Account"
        value={
          <div className="flex items-center flex-shrink-0">
            <LinkIcon type={linkType} />
            <div className="truncate ml-[2px]">{externalAccountName}</div>
          </div>
        }
        textToCopy={externalAccountName}
      />
      <DetailHeaderRow
        label="External ID"
        value={externalAccountId}
        textToCopy={externalAccountId}
      />
      <DetailHeaderRow
        label="Currency"
        value={<span>{formatAccountCurrency(currencyMode, currency)}</span>}
      />
      {accountSelector}
    </DetailHeaderSection>
  </DetailHeader>
);
